import { Component, OnInit } from '@angular/core';
import { IPerson } from 'src/app/models/i-person';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { PersonService } from 'src/app/services/person.service';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCar, faHome, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IVehicle } from 'src/app/models/i-vehicle';
import { IProperty } from 'src/app/models/i-property';
import { VehicleService } from 'src/app/services/vehicle.service';
import { PropertyService } from 'src/app/services/property.service';
import { CrediserverService } from 'src/app/services/crediserver.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Constants } from 'src/app/common';

@Component({
  selector: 'app-crediserver',
  templateUrl: './crediserver.component.html',
  styleUrls: ['./crediserver.component.css']
})
export class CrediserverComponent implements OnInit {

  people: IPerson[]

  personSelected: IPerson;
  vehiclesSelected: IVehicle[];
  propertiesSelected: IProperty[];

  CurrentPage: number = 1;
  PageSize: number = 8;
  CollectionSize: number = 1;
  SearchForm: FormGroup;

  search: boolean;

  constructor(
    private personService: PersonService,
    private crediserverService: CrediserverService,
    private blockUiHanddler: BlockUiHandlerService,
    private alertsService: AlertsService,
    private modalService: NgbModal,
    private vehicleService: VehicleService,
    private propertyService: PropertyService,
    private formBuilder: FormBuilder,
    library: FaIconLibrary
    ) {
      library.addIcons(faInfoCircle, faCar, faHome) 
  }

  ngOnInit(): void {
    this.InitVariables();
    this.ResetSearchForm();
    this.LoadPeoplePagedCount();
  }

  InitVariables(){
    this.people = [];
    this.search = false;
  }

  ResetSearchForm(): void {
    let LastMonthDate = new Date();
    LastMonthDate.setMonth(LastMonthDate.getMonth() - 1);
    let MonthDate = formatDate(LastMonthDate, 'yyyy-MM-dd', 'en');
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.SearchForm = this.formBuilder.group({
      Card: [''],
      Filter: [''],
      From: [MonthDate, Validators.required],
      To: [NowDate, Validators.required],
    });
  }

  LoadPeoplePagedCount(){
    this.search = false;
    this.blockUiHanddler.Start(1, 'Cargando paginación de personas...')
    this.personService.GetPeopleCount(
      this.SearchForm.controls['Card'].value,
      this.SearchForm.controls['Filter'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value
    ).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.CollectionSize = req.Data;
      this.LoadPeople();
      }
    }, err => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowSmallCornerAlert(err, 2)
    });
  }

  LoadPeople(){
    this.blockUiHanddler.Start(1, 'Cargando personas...')
    this.personService.GetPeoplePaged(
      this.SearchForm.controls['Card'].value,
      this.SearchForm.controls['Filter'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value,
      ((this.CurrentPage*this.PageSize)-this.PageSize),
      this.PageSize
    ).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.people = req.Data;
      }
    }, err => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowSmallCornerAlert(err, 2)
    }); 
  }

  openPersonInfo(content, person: IPerson){
    this.personSelected = person;
    this.modalService.open(content, {size: 'lg'});
  }

  openVehicles(content, person: IPerson){
    this.vehiclesSelected = person.Vehicles;
    if(this.vehiclesSelected.length) this.modalService.open(content, {size: 'lg'});
  }

  openProperties(content, person: IPerson){
    this.propertiesSelected = person.Properties;
    if(this.propertiesSelected.length) this.modalService.open(content, {size: 'lg'});
  }

  SelectPage(Page: string): void {
    this.CurrentPage = (parseInt(Page, 10) || 1);
  }

  FormatInput(input: HTMLInputElement): void {
    input.value = input.value.replace(Constants.FILTER_PAG_REGEX, '');
  }

  ValidateDate(fieldKey: string){
    this.search = true;
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if(!this.SearchForm.controls[fieldKey].value) this.SearchForm.controls[fieldKey].setValue(NowDate);
    if(parseInt(formatDate(this.SearchForm.controls[fieldKey].value, 'yyyy', 'en')) > 9999) this.SearchForm.controls[fieldKey].setValue(NowDate);
  }
}
